var _circle, _path, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 15.5,
    stroke: "#EAEAEA",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 9.25C13.32 9.25 10.75 11.55 10.75 14.4C10.75 14.95 11.2 15.4 11.75 15.4H12.65C13.2 15.4 13.65 14.95 13.65 14.4C13.65 12.95 14.95 11.75 16.5 11.75C18.05 11.75 19.35 12.95 19.35 14.35C19.35 15.45 18.7 16.15 17.45 16.85C16.1 17.6 15.25 18.85 15.25 20.35V20.5C15.25 21.05 15.7 21.5 16.25 21.5H16.75C17.3 21.5 17.75 21.05 17.75 20.5V20.35C17.75 19.55 18.2 18.95 19.15 18.45C20.75 17.55 22.25 16.35 22.25 14.35C22.25 11.4 19.55 9.25 16.5 9.25Z",
    fill: "#484C50"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 24.25,
    r: 1.35,
    fill: "#971FB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.2192bc67cd1ef22c5a0b44ff554c2bd5.svg";
export { ForwardRef as ReactComponent };